import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-modern-cta',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './modern-cta.html',
  styleUrls: ['./modern-cta.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModernCta {
  @Input() badgeLabel = '';
  @Input({ required: true }) heading!: string;
  @Input() description = '';

  @Input() secondaryLabel = 'Talk to Sales';
  @Input() secondaryLink = '/contact-us';
  @Input() secondaryQueryParams?: Record<string, string>;

  /** Short keyword pills shown below the button (omit for none). */
  @Input() tags: string[] = [];

  /** Color of the soft glow in the card's bottom-right corner (any valid CSS color/rgba). */
  @Input() bottomGlow = 'rgba(255, 255, 255, 0.25)';
}
